import { useEffect, useState } from "react";

import { FilterSelectField } from "components/formFields/FilterSelectField";

import { i18n } from "services/i18nService";
import { getList } from "services/sosInventoryService/sosApi";

import { OBJECT_TYPES } from "appConstants";

const anyOption = { id: 0, name: i18n("filter.Any") };
const unassignedOption = { id: "-1", name: i18n("filter.Unassigned") };

export function EditAssignedToFilter(props) {
  const { filters, setFilters, objectType } = props;

  const { filterSettings } = filters;
  const { UserId } = filterSettings;

  const [users, setUsers] = useState([]);

  useEffect(() => {
    async function getUsers() {
      const users = await getList("user", { status: "active" });
      setUsers(users.map(({ id, name }) => ({ name, id: id.toString() })));
    }
    getUsers();
  }, []);

  function handleChange(_, value) {
    setFilters((prevParams) => ({
      ...prevParams,
      filterSettings: {
        ...prevParams.filterSettings,
        UserId: value?.id || "",
      },
      startingRecord: 1,
    }));
  }

  const options = [anyOption, unassignedOption, ...users];

  const label =
    objectType === OBJECT_TYPES.AUDIT_EVENT.fullString
      ? i18n("filter.User")
      : i18n("filter.AssignedTo");

  return (
    <FilterSelectField
      options={options}
      onValueChange={handleChange}
      value={UserId ? { id: UserId } : anyOption}
      label={label}
      dataTesting="assignedToFilter"
      disableClearable
    />
  );
}
